import { render, staticRenderFns } from "./category-item.vue?vue&type=template&id=1eb94d17&scoped=true&lang=html"
import script from "./category-item.vue?vue&type=script&lang=js"
export * from "./category-item.vue?vue&type=script&lang=js"
import style0 from "./category-item.vue?vue&type=style&index=0&id=1eb94d17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb94d17",
  null
  
)

export default component.exports